export default __webpack_public_path__ + "static/media/babcock-logo.ec592e9e.svg";